/* eslint-disable */
// Test-mode banner intentionally disabled (production launch prep).
// Keeping the file around in case we want to re-enable the banner later.
export default function TestModeBanner() {
  return null;
}
